<template>
  <component
    v-if="hasChild()"
    :is="getComponent()"
    class="ao__heading"
  >
    <DefaultArticlesArtObject
      v-for="(paragraphContent, index) in props.payload?.content"
      :type="paragraphContent?.type"
      :payload="paragraphContent"
      :parent-ident="`${props.parentIdent}|paragraph-${index}`"
    />
  </component>
  <component
    v-else
    :is="getComponent()"
    class="ao__heading"
  >
    <span v-html="props.payload?.rendered" />
  </component>
</template>

<script setup lang="ts">
const props = defineProps({
  type: { type: String, required: true },
  payload: { type: Object, required: false },
  parentIdent: { type: String, required: false },
})

const getComponent = () => {
  return `h${props.payload?.attributes?.level || 3}`
}

const hasChild = () => {
  return !!(props.payload?.content && props.payload?.content.length > 0)
}
</script>

<style lang="postcss" scoped>
</style>